var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestinationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.169 9C19.169 15.2222 10.4946 20.5556 10.4946 20.5556C10.4946 20.5556 1.82031 15.2222 1.82031 9C1.82031 6.87827 2.73421 4.84344 4.36096 3.34315C5.98772 1.84285 8.19407 1 10.4946 1C12.7952 1 15.0016 1.84285 16.6283 3.34315C18.2551 4.84344 19.169 6.87827 19.169 9Z",
    stroke: "#EE3B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4969 11.6668C12.0938 11.6668 13.3884 10.4729 13.3884 9.00016C13.3884 7.5274 12.0938 6.3335 10.4969 6.3335C8.90001 6.3335 7.60547 7.5274 7.60547 9.00016C7.60547 10.4729 8.90001 11.6668 10.4969 11.6668Z",
    stroke: "#EE3B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationIcon);
export default __webpack_public_path__ + "static/media/destination_icon.a001c5b16d7986a1ca3a7b82ccd41ae2.svg";
export { ForwardRef as ReactComponent };